import { render, staticRenderFns } from "./ItemTypeGroup.vue?vue&type=template&id=2d749f14"
import script from "./ItemTypeGroup.vue?vue&type=script&lang=js"
export * from "./ItemTypeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports